import { Alert, CircularProgress, Stack } from '@mui/material';
import { Suspense, lazy, type ComponentType } from 'react';
import { useIntl } from 'react-intl';

import { createAuthorizationHeaders } from '../../api/httpClient';
import RemoteBoundary from '../../components/AppLayout/RemoteBoundary';
import { useUserData } from '../../redux/selectors';

interface OnboardingUsersPageProps {
  apiConfig?: {
    authV3Base: string;
    getAuthHeaders?: () => Promise<HeadersInit | undefined>;
  };
  locale?: string;
}

const OnboardingUsersPage = lazy<ComponentType<OnboardingUsersPageProps>>(
  () => import('onboardingMicrofrontend/OnboardingUsersPage')
);

const OnboardingUsers = (): React.JSX.Element => {
  const intl = useIntl();
  const user = useUserData();
  const authV3Base = import.meta.env.VITE_AUTH_V3_BASE;

  const apiConfig = {
    authV3Base,
    getAuthHeaders: createAuthorizationHeaders,
  };

  return (
    <RemoteBoundary
      name='OnboardingUsersPage'
      microfrontend='onboarding-mf'
      fallback={
        <Alert severity='warning'>{intl.formatMessage({ id: 'onboardingUnavailable' })}</Alert>
      }
    >
      <Suspense
        fallback={
          <Stack
            alignItems='center'
            padding={4}
          >
            <CircularProgress />
          </Stack>
        }
      >
        <OnboardingUsersPage
          apiConfig={apiConfig}
          locale={user.locale ?? 'en'}
        />
      </Suspense>
    </RemoteBoundary>
  );
};

export default OnboardingUsers;
